import { Extension } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'
import { DOMParser as ProseMirrorDOMParser } from 'prosemirror-model'

export const CleanPastedBullets = Extension.create({
  name: 'cleanPastedBullets',

 addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handlePaste(view, event) {
            const clipboardData = event.clipboardData
            const html = clipboardData?.getData('text/html')
            const text = clipboardData?.getData('text/plain')

            if (!html && !text) return false

            const bulletSymbols = [
              '•', // bullet (U+2022)
              '▪', // small black square (U+25AA)
              '‣', // triangle bullet (U+2023)
              '·', // middle dot (U+00B7)
              '–', // en dash (U+2013)
              '-', // hyphen
              '§', // section (rare)
              '○', // white circle (U+25CB)
              '$', // weird paste artifact
              'o'
            ]

            const isBulletLine = line =>
              bulletSymbols.some(symbol => line.trim().startsWith(symbol))

            // If pasting plain text (no HTML), try to clean it
            if (!html && text) {
              const lines = text.split('\n').filter(l => l.trim() !== '')
              const allBullets = lines.every(isBulletLine)

              if (allBullets) {
                const cleanedItems = lines.map(line =>
                  line.trim().replace(/^([^\w\s]{1,2})\s*/, '')
                )
                const htmlList = `<ul>${cleanedItems
                  .map(item => `<li>${item}</li>`)
                  .join('')}</ul>`

                const dom = new DOMParser().parseFromString(htmlList, 'text/html')
                const fragment = ProseMirrorDOMParser.fromSchema(view.state.schema).parse(
                  dom.body
                )

                view.dispatch(
                  view.state.tr.replaceSelectionWith(fragment).scrollIntoView()
                )
                return true
              }
              return false
            }

            // If pasting from Word (HTML), parse and clean manually
            if (html) {
              const dom = new DOMParser().parseFromString(html, 'text/html')
              const paragraphs = Array.from(dom.querySelectorAll('p'))

              const bulletParas = paragraphs.filter(p =>
                isBulletLine(p.textContent)
              )
              if (!bulletParas.length) return false

              let htmlList = '<ul>';
              let nesting = 1;
              let holdNesting = nesting;

              for(var i = 0; i < bulletParas.length; i++){
                holdNesting = nesting;
                var textVal = bulletParas[i].textContent.trim().replace(/^[^\n]*\n/, '')
                if(!bulletParas[i].style.marginLeft){
                  nesting = 1;
                  if(i != 0){htmlList = checkNesting(holdNesting, nesting, htmlList);}
                  htmlList += '<li><p>' + textVal + '</p>'
                } else if(bulletParas[i].style.marginLeft == "1in"){
                  nesting = 2;
                  htmlList = checkNesting(holdNesting, nesting, htmlList);
                  if(holdNesting < nesting){htmlList += '<ul>'}
                  htmlList += '<li><p>' + textVal + '</p>'
                }
                else if(bulletParas[i].style.marginLeft == "1.5in"){
                  nesting = 3;
                  htmlList = checkNesting(holdNesting, nesting, htmlList);
                  if(holdNesting < nesting){htmlList += '<ul>'}
                  htmlList += '<li><p>' + textVal + '</p>'
                }else if(bulletParas[i].style.marginLeft == "2in"){
                  nesting = 3;
                  htmlList = checkNesting(holdNesting, nesting, htmlList);
                  if(holdNesting < nesting){htmlList += '<ul>'}
                  htmlList += '<li><p>' + textVal + '</p>'
                }
              }
              htmlList = checkNesting(nesting, 1, htmlList);
              htmlList += "</ul>"
              
              const cleanDom = new DOMParser().parseFromString(htmlList, 'text/html')
              const fragment = ProseMirrorDOMParser.fromSchema(view.state.schema).parse(
                cleanDom.body
              )

              view.dispatch(
                view.state.tr.replaceSelectionWith(fragment).scrollIntoView()
              )
              return true
            }

            return false
          },
        },
      }),
    ]
  },
})

function checkNesting(holdNesting, nesting, htmlList){
    if(holdNesting == nesting){
        htmlList += "</li>"
    } else if(holdNesting > nesting){
        htmlList += '</li></ul>'
        htmlList = checkNesting(holdNesting - 1, nesting, htmlList)
    }
    return htmlList;
}